import { initAPM } from './factory';

export function initDatadog(): void {
  initAPM().catch((e) => console.warn('[apm] init failed', e));
}
